import { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { browserHistory, withRouter } from 'react-router'
import { AutocompleteHOC, TrackingHOC, ProductNameHOC } from 'hocs'
import { selectIsStarted } from 'containers/CallHandler/selectors'
import { selectDevices } from '../DeviceSlider/selectors'
import { updatePhoneId } from '../App/actions'
import { selectCurrentPhone } from '../App/selectors'
import DeviceSearch from 'components/DeviceSearch'
import { selectHighlight, selectLocation } from './selectors'

const deviceFullName = (device) =>
  device ? `${device.manufacturer} ${device.name}` : ''

const DeviceSearchContainer = ({
  currentDevice,
  setValue,
  location,
  highlight,
  isStarted,
  devices,
  updatePhoneId,
  createEvent,
  productNameSingular,
  state: { value, suggestions },
  changeHandler,
  onSuggestionsClearRequested,
  setSuggestions,
  router
}) => {
  const inputRef = useRef(null)

  useEffect(() => {
    setValue(deviceFullName(currentDevice))
  }, [currentDevice])

  useEffect(() => {
    if (highlight) {
      inputRef.current.focus()
    }
  }, [location])

  useEffect(() => {
    if (!isStarted) {
      setValue('')
      updatePhoneId(null)
    }
  }, [isStarted])

  const selectHandler = (event, { suggestion: { id, name } }) => {
    updatePhoneId(id, name)
    const path = router.location.pathname
    const resource = path.split('/')[1]
    browserHistory.push(`/${resource}${resource.endsWith('s') ? '' : 's'}`)

    createEvent({
      category: 'devicesearch',
      data: { action: 'setDevice', device: { id, name } }
    })
  }

  const getSuggestions = (value) =>
    devices.filter((device) => {
      const fullname = deviceFullName(device)
      return fullname.toLowerCase().indexOf(value.toLowerCase()) !== -1
    })

  const blurHandler = () => {
    // Reset search value if no device was selected
    if (value !== deviceFullName(currentDevice)) {
      setValue(deviceFullName(currentDevice))
    }
  }

  const submitHandler = (e) => {
    e.preventDefault()

    // Set first suggestion as selection when hitting enter
    if (suggestions.length > 0) {
      selectHandler(null, { suggestion: suggestions[0] })
    }
  }

  const inputProps = {
    placeholder: productNameSingular
      ? `Filter by ${productNameSingular}`
      : 'Filter by Product',
    value,
    onChange: changeHandler,
    onBlur: blurHandler,
    autoFocus: ['/faqs', '/tutorials'].includes(location)
  }

  const autosuggestProps = {
    inputProps,
    onSuggestionSelected: selectHandler,
    onSuggestionsFetchRequested: ({ value }) =>
      setSuggestions(getSuggestions(value)),
    onSuggestionsClearRequested,
    suggestions,
    getSuggestionValue: (suggestion) => deviceFullName(suggestion)
  }

  const props = {
    autosuggestProps,
    clearHandler: () => setValue(''),
    submitHandler,
    highlight
  }

  return <DeviceSearch {...props} inputRef={inputRef} />
}

const mapStateToProps = (state) => ({
  devices: selectDevices(state),
  currentDevice: selectCurrentPhone(state),
  highlight: selectHighlight(state),
  location: selectLocation(state),
  isStarted: selectIsStarted(state)
})

const mapDispatchToProps = (dispatch) => ({
  updatePhoneId: (phoneId, deviceName) =>
    dispatch(updatePhoneId(phoneId, deviceName))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    TrackingHOC(AutocompleteHOC(ProductNameHOC(DeviceSearchContainer)))
  )
)
